import * as React from 'react';

import { PromoItem } from '../../../components/PromoItem';
import { IPromoInfoSchema } from '../../../repositories/newbuilding-card/entities/promo/PromoInfoSchema';

interface IPromoContainerProps {
  onClick(promo: IPromoInfoSchema): void;
  promo: IPromoInfoSchema;
}

export const PromoItemContainer: React.FC<IPromoContainerProps> = ({ onClick, promo }) => {
  const handleClick = React.useCallback(() => {
    onClick(promo);
  }, [promo, onClick]);

  return <PromoItem promo={promo} onClick={handleClick} />;
};
